import { isAxiosError } from 'axios';

/**
 * Pull a human-readable message out of a portal API error.
 *
 * The backend answers in three shapes: a domain error ({message, code}), a
 * serializer error keyed by field ({readings: [{message}]}), and DRF's plain
 * {detail}. Falling back to `fallback` keeps a client from ever seeing a raw
 * error object.
 */
export const extractPortalError = (error: unknown, fallback: string): string => {
  if (!isAxiosError(error) || !error.response?.data) return fallback;

  const data = error.response.data as Record<string, any>;

  if (typeof data.message === 'string') return data.message;
  if (typeof data.detail === 'string') return data.detail;
  if (typeof data.detail?.message === 'string') return data.detail.message;

  for (const value of Object.values(data)) {
    if (Array.isArray(value) && value.length) {
      const first = value[0];
      if (typeof first === 'string') return first;
      if (typeof first?.message === 'string') return first.message;
    }
  }

  return fallback;
};
